export default __webpack_public_path__ + "static/media/x-blue-cross.d9886a21.svg";